module.exports = __webpack_public_path__ + "img/swipe.9fc674ae.png";